import { useUser } from "@clerk/clerk-react";
import { useContext, useEffect } from "react";
import { BaseContext } from "../base-context";
import { useMutation } from "convex/react";
import { api } from "../../convex/_generated/api";
import { useStableQuery } from "./useStableQuery";
import { useLoginStreak } from "./useLoginStreak";

export const useConvexUser = () => {
  const { user } = useUser();
  const email = user?.primaryEmailAddress?.emailAddress || '';
  const convexUser = useStableQuery(api.users.getUserByEmail, { email });
  const addUser = useMutation(api.users.addUser);
  const { setConvexUserId, convexUserId } = useContext(BaseContext);

  useEffect(() => {
    if (user) {
      if (convexUser === null && email) {
        addUser({
          email,
          lastName: user.lastName || null,
          firstName: user.firstName || null
        }).then(convexUserId => setConvexUserId(convexUserId));
      } else {
        if (!!convexUser) {
          setConvexUserId(convexUser._id);
        }
      }
    }
  }, [user, convexUser]);

  // Track login streak after user is synced
  const loginStreak = useLoginStreak(convexUserId || null);

  return {
    user,
    convexUser,
    loginStreak,
  };
};
